import React, { ReactNode } from "react";
import T from "../../../../common/i18n/Text";
import "./Section.css"

interface Props {
    titlePath: string;
    children: ReactNode;
}

const Section = ({titlePath, children}: Props) => {
    return (
        <div className="section">
            <h2>
                <T path={titlePath} />
            </h2>
            {children}
        </div>
    )
}

export default Section;
